import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

const toCategorySeoTitle = (metaTitle, categoryName) =>
  metaTitle || `${categoryName} em Promoção | É no Promobit`;

const toCategorySeoDescription = (metaDescription, categoryName) =>
  metaDescription ||
  `As melhores promoções de ${categoryName} você vai encontrar aqui no Promobit! Confira as melhores ofertas disponíveis acessando nosso site. Aproveite!`;

const CategoryHead = ({
  categoryName,
  metaTitle = null,
  metaDescription = null,
}) => (
  <NextSeo
    description={toCategorySeoDescription(metaDescription, categoryName)}
    openGraph={{
      title: toCategorySeoTitle(metaTitle, categoryName),
      description: toCategorySeoDescription(metaDescription, categoryName),
    }}
    title={toCategorySeoTitle(metaTitle, categoryName)}
  />
);

CategoryHead.propTypes = {
  categoryName: PropTypes.string.isRequired,
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
};

export default CategoryHead;
